// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"1146b8b3","615":"1398cf6a"}[chunkId] + ".chunk.js";
};